import React from "react";
import styled from "styled-components";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink, useLocation } from "react-router-dom";
// Assets
import CloseIcon from "../../assets/svg/CloseIcon";

const NAV_ITEMS = [
  { to: "home", label: "Home" },
  { to: "wings", label: "Our Wings" },
  { to: "projects", label: "Success Stories" },
  { to: "blog", label: "Blog" },
  { to: "reviews", label: "Reviews" },
  { to: "contact", label: "Contact" },
];

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  const location = useLocation();
  const isLanding = location.pathname === "/";
  const closeSidebar = () => toggleSidebar(false);
  const linkStyle = { padding: "10px 15px" };

  return (
    <Wrapper className="animate" sidebarOpen={sidebarOpen}>
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          <LogoImage src="/logo.png" alt="AFRIQ Logo" />
          <h1 className="whiteColor font20 extraBold" style={{ marginLeft: "15px" }}>
            AFRIQ
          </h1>
        </div>
        <CloseBtn onClick={closeSidebar} className="animate pointer">
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn">
        {NAV_ITEMS.map(({ to, label }) => (
          <li key={to} className="semiBold font15 pointer">
            {isLanding ? (
              <ScrollLink
                onClick={closeSidebar}
                activeClass="active"
                className="whiteColor"
                style={linkStyle}
                to={to}
                spy={true}
                smooth={true}
                offset={-60}
              >
                {label}
              </ScrollLink>
            ) : (
              <RouterLink to={`/#${to}`} className="whiteColor" style={linkStyle} onClick={closeSidebar}>
                {label}
              </RouterLink>
            )}
          </li>
        ))}
      </UlStyle>
      <UlStyle className="flexSpaceCenter">
        <li className="semiBold font15 pointer">
          <RouterLink to="/tutor-apply" style={{ padding: "10px 30px 10px 0" }} className="whiteColor" onClick={closeSidebar}>
            Join AFRIQ as a Tutor
          </RouterLink>
        </li>
        <li className="semiBold font15 pointer flexCenter">
          <RouterLink to="/apply" className="radius8 whiteBg" style={{ padding: "10px 15px", color: "#4b2e83", fontWeight: "600" }} onClick={closeSidebar}>
            Apply now
          </RouterLink>
        </li>
      </UlStyle>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 320px;
  max-width: 85vw;
  height: 100vh;
  position: fixed;
  top: 0;
  padding: 0 25px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-320px")};
  z-index: 9999;
  background: #4b2e83;
  backdrop-filter: blur(20px);
  transition: right 0.3s ease;
  overflow-y: auto;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 480px) {
    width: 100%;
    max-width: 100%;
    right: ${(props) => (props.sidebarOpen ? "0px" : "-100%")};
  }
`;

const SidebarHeader = styled.div`
  padding: 20px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
`;

const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 12px;
  min-width: 44px;
  min-height: 44px;
  color: white;
  transition: all 0.3s ease;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
  &:hover, &:active {
    background: rgba(255, 255, 255, 0.1);
  }
`;

const UlStyle = styled.ul`
  padding: 30px 0;
  
  li {
    margin: 12px 0;
    
    a {
      transition: all 0.3s ease;
      border-radius: 8px;
      display: block;
      min-height: 44px;
      display: flex;
      align-items: center;
      
      &:hover, &:active {
        background: rgba(255, 255, 255, 0.1);
        transform: translateX(5px);
      }
    }
  }
  
  &:last-child {
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    padding-top: 20px;
    margin-top: 20px;
    
    li a {
      min-height: 48px;
      font-weight: 600;
    }
  }
  
  @media (max-width: 480px) {
    padding: 25px 0;
  }
`;

const LogoImage = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
`;
